/**
 * @generated SignedSource<<d762a3395449e30e12630a5f2f7a6f3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableContainer_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRefetchableSimilarItemsGrid_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetailsLazy_user" | "PdpRespSharedSidebarSellerInfoAndContact_user" | "PdpRespUnavailableDetailsTabs_user" | "PdpRespUnavailableHeader_user" | "PdpSharedItemFavorites_user" | "PdpSharedSellerItemsCarousel_user" | "PdpSharedYMALItemsCarousel_user" | "usePdpSharedTracking_user">;
  readonly " $fragmentType": "PdpRespUnavailableContainer_user";
};
export type PdpRespUnavailableContainer_user$key = {
  readonly " $data"?: PdpRespUnavailableContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    {
      "kind": "RootArgument",
      "name": "isSoldPDPV3Variant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableContainer_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableHeader_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespUnavailableDetailsTabs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_user"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedItemFavorites_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedSidebarSellerInfoAndContact_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_user"
    },
    {
      "condition": "isSoldPDPV3Variant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedYMALItemsCarousel_user"
        }
      ]
    },
    {
      "condition": "isSoldPDPV3Variant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespRefetchableSimilarItemsGrid_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpSharedTracking_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "51245d41a1436ce27e3351238beca2de";

export default node;
